<template>
  <h1>{{ getMessageByLang('productsText', 'Товары')}}</h1>
  <Grid ref="grid" :style="{ height: '640px' }" :data-items="gridData" :edit-field="'inEdit'" :sortable="true"
    :sort="sort" :pageable="pageable" :take="take" :skip="skip" :total="total" :loader="loader"
    @datastatechange="dataStateChange" :columns="columns">
    <template v-slot:supplierTemplate="{ props }">
      <td :class="props.className">{{ props?.dataItem[props.field]?.name || '' }}</td>
    </template>
    <template v-slot:categoryTemplate="{ props }">
      <td :class="props.className">{{ props?.dataItem[props.field]?.name || '' }}</td>
    </template>
    <template v-slot:operation="{ props }">
      <td class="k-command-cell k-table-td">
        <div class="cell-control">
          <router-link :to="{ name: routeNameProductEdit, params: { 'id': props.dataItem.id } }">
            <Button title="Edit" :theme-color="'primary'" :svg-icon="pencilIcon">
            </Button>
          </router-link>

          <Button class="k-grid-remove-command" @click="showModalDelete(props.dataItem)" :svg-icon="trashIcon">
          </Button>
        </div>
      </td>
    </template>
    <GridToolbar>
      <router-link :to="{ name: linkCreateProduct }">
        <Button title="Add new" :theme-color="'primary'">
          {{ getMessageByLang('addText', 'Добавить') }}
        </Button>
      </router-link>
    </GridToolbar>
    <GridNoRecords> {{  getMessageByLang('There is no data available custom', 'There is no data available custom') }} </GridNoRecords>
  </Grid>

  <ModalDelete v-if="isShowModalDelete" @accept="modalDeleteAccept" @cancel="modalDeleteCancel" />
</template>

<script>
import { Grid, GridToolbar, GridNoRecords } from '@progress/kendo-vue-grid';
import { Button } from '@progress/kendo-vue-buttons';
import { cancelIcon, saveIcon, pencilIcon, trashIcon } from '@progress/kendo-svg-icons';
import { dataString } from '../../composables/dataString';
import axios from "axios";
import { getMessageByLang } from '@/utils/translate.js';
import { getUrlWithRole } from '@/utils/router';
import ModalDelete from '@/components/modals/ModalDelete.vue';
import {addListener, removeListener} from "@/utils/app";

export default {
  components: {
    Grid,
    GridToolbar,
    GridNoRecords,
    Button,
    ModalDelete
  },
  data: function () {
    return {
      getMessageByLang: getMessageByLang,
      pencilIcon,
      trashIcon,
      cancelIcon, saveIcon,
      filter: null,
      sort: null,
      pageable: true,
      gridData: [],
      skip: 0,
      take: 10,
      total: 0,
      updatedData: [],
      editID: null,
      loader: false,
      isShowModalDelete: false,
      deleteItem: null
    };
  },
  computed: {
    routeNameProductEdit() {
      const role = getUrlWithRole();

      if(role === 'supplier/') {
        return 'supplierproductEdit'
      }

      return 'productEdit'
    },

    linkCreateProduct() {
      const role = getUrlWithRole();

      if(role === 'supplier/') {
        return 'supplierproductCreate'
      }

      return 'productCreate'
    },

    columns() {
      const role = getUrlWithRole();

      if(role === 'supplier') {
        return [
          { field: 'id', width: 60, title: 'ID' },
          { field: 'category', title: getMessageByLang('categoryText', 'Категория'), cell: 'categoryTemplate' },
          { field: 'name', title: getMessageByLang('nameProduct', 'Название товара') },
          { field: 'base_price', title: getMessageByLang('basePrice', 'Базовая цена') },
          { field: 'visible', title: getMessageByLang('flagVisible', 'Флаг видимости') },
          { cell: 'operation', filterable: false, width: '150px' },
        ]
      }

      return [
        { field: 'id', width: 60, title: 'ID' },
        { field: 'supplier', title: getMessageByLang('supplierText', 'Поставщик'), cell: 'supplierTemplate' },
        { field: 'category', title: getMessageByLang('categoryText', 'Категория'), cell: 'categoryTemplate' },
        { field: 'name', title: getMessageByLang('nameProduct', 'Название товара') },
        { field: 'base_price', title: getMessageByLang('basePrice', 'Базовая цена') },
        { field: 'visible', title: getMessageByLang('flagVisible', 'Флаг видимости') },
        { cell: 'operation', filterable: false, width: '150px' },
      ]
    },
    dataState() {
      return {
        sort: this.sort,
        skip: this.skip,
        take: this.take,
      };
    },
  },
  created: function () {
    this.getData();
    addListener(this.addEscListener)
  },

  unmounted() {
    removeListener(this.addEscListener)
  },

  methods: {
    addEscListener(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.isShowModalDelete = false;
      }
    },

    showModalDelete(item) {
      this.deleteItem = item;
      this.isShowModalDelete = true;
    },

    modalDeleteAccept() {
      this.remove(this.deleteItem);
    },

    modalDeleteCancel() {
      this.isShowModalDelete = false;
    },
    
    remove(dataItem) {
      var self = this;

      const role = getUrlWithRole();
      let url = '/api/v1/products';

      if (role === 'supplier/') {
        url = '/api/v1/supplier/products'
      }

      axios.delete(`${url}/${dataItem.id}`)
        .then(res => {
          if (res.data) {
            if (res.data.message) {
              this.isShowModalDelete = false;
              self.getData();
            }
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response);
          }
        });
    },
    cloneProduct(item) {
      return Object.assign({}, item);
    },
    getData: function () {
      const that = this;
      this.loader = true;

      const role = getUrlWithRole();
      let url = '/api/v1/products';

      if (role === 'supplier/') {
        url = '/api/v1/supplier/products'
      }


      axios.get(`${url}?` + dataString(this.dataState))
        .then(res => {
          if (res.data && res.data.message) {
            that.total = res.data.total;
            that.updatedData = [...res.data.data];
            that.gridData = res.data.data;

          } else {
            that.total = 0;
            that.updatedData = [];
            that.gridData = [];
          }

          this.loader = false;
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.data.message) {
              // $toast.error(error.response.data.message);
              alert(that.getMessageByLang('error', "Ошибка"))
              
            }
          } else if (error.request) {
            console.log(error.request);
          }
        });
    },
    createAppState: function (dataState) {
      this.take = dataState.take;
      this.skip = dataState.skip;
      this.filter = dataState.filter;
      this.sort = dataState.sort;
      this.getData();
    },
    dataStateChange: function (event) {
      this.createAppState(event.data);
    },
  },
};
</script>
